export default __webpack_public_path__ + "static/media/PlayWhite.38892826.svg";